// Bootstrap breakpoints https://getbootstrap.com/docs/5.2/layout/breakpoints/
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
const mediaQueries = {
    from: (breakpoint) => `@media screen and (min-width: ${breakpoints[breakpoint]}px)`,
    to: (breakpoint) => `@media screen and (max-width: ${breakpoints[breakpoint] - 0.02}px)`,
};
export default mediaQueries;
export { breakpoints };
